import BankTransferContent from './BankTransferContent';

export default BankTransferContent;
